/* global axios */
import ApiClient from './ApiClient';

class LeadNetworkAPI extends ApiClient {
  constructor() {
    super('lead_networks', { accountScoped: true });
  }

  getMemberships() {
    return axios.get(`${this.baseUrl()}/lead_network_memberships/me`);
  }

  getNetworks() {
    return axios.get(this.url);
  }

  join(networkId) {
    return axios.post(`${this.url}/${networkId}/join`);
  }

  close(networkId) {
    return axios.post(`${this.url}/${networkId}/close`);
  }

  getNetworkMembers(networkId) {
    return axios.get(`${this.url}/${networkId}/memberships`);
  }

  inviteMember(networkId, payload) {
    return axios.post(`${this.url}/${networkId}/invite`, payload);
  }

  acceptInvite(membershipId) {
    return axios.post(
      `${this.baseUrl()}/lead_network_memberships/${membershipId}/accept`
    );
  }

  declineInvite(membershipId) {
    return axios.post(
      `${this.baseUrl()}/lead_network_memberships/${membershipId}/decline`
    );
  }

  getPings() {
    return axios.get(`${this.baseUrl()}/lead_pings`);
  }

  getPing(id) {
    return axios.get(`${this.baseUrl()}/lead_pings/${id}`);
  }

  ackPing(id) {
    return axios.post(`${this.baseUrl()}/lead_pings/${id}/ack`);
  }

  deletePing(id) {
    return axios.delete(`${this.baseUrl()}/lead_pings/${id}`);
  }

  convertPingToEvent(id) {
    return axios.post(`${this.baseUrl()}/lead_pings/${id}/convert_to_event`);
  }

  bidPing(id, amount) {
    return axios.post(`${this.baseUrl()}/lead_pings/${id}/bid`, { amount });
  }

  getMatch(id) {
    return axios.get(`${this.baseUrl()}/lead_matches/${id}`);
  }

  sellEvent(eventId, payload) {
    return axios.post(
      `${this.baseUrl()}/planning/events/${eventId}/sell_to_network`,
      payload
    );
  }

  getLedger(params = {}) {
    return axios.get(`${this.baseUrl()}/lead_network_ledger`, { params });
  }

  updatePreferences(membershipId, preferences) {
    return axios.patch(
      `${this.baseUrl()}/lead_network_memberships/${membershipId}/preferences`,
      {
        notification_preferences: preferences,
      }
    );
  }
}

export default new LeadNetworkAPI();
